export const openPdf = async (render: () => Promise<string | null>) => {
  // safari prevents popups after async function therefore window has to be open before
  const windowRef = window.open();
  if (!windowRef) {
    throw new Error('could not open new window');
  }
  const base64string = await render();
  if (!base64string) {
    windowRef.close();
    throw new Error('Invalid Base64 string');
  }
  const pdfBlob = toPDFBlob(base64string);
  const blobURL = URL.createObjectURL(pdfBlob);
  windowRef.location = blobURL;
};

/**
 * Converts a base64-encoded string into a PDF Blob.
 * Cannot return the Blob directly from the server since only plain objects can be passed to Client Components from Server Components
 *
 * @param base64string - The base64 encoded string.
 * @returns The decoded pdf blob
 */
export function toPDFBlob(base64string: string): Blob {
  return new Blob([Buffer.from(base64string, 'base64')], { type: 'application/pdf' });
}
